/* ===========================================================
   Elite Supplements — Store Detail Page
   Live Google Places data (matches store-locator pattern):
   Maps JS API + PlacesService.getDetails.

   Populates these hooks inside #store-page:
     [data-place-score]    → rating number (e.g. 4.8)
     [data-place-count]    → "327 Google reviews"
     [data-place-status]   → status pill (Open now / Closed)
     [data-place-statuslabel] → "Closes 6:00 PM ..." line
     [data-place-hours]    → hours table (rebuilt rows)
     [data-place-reviews]  → review cards (up to 4)
     [data-place-address]  → formatted address text
     [data-place-phone]    → phone display text
     a[href^="tel:"]       → tel links (within .store-page)
   =========================================================== */
(function () {
  'use strict';

  var GMAPS_KEY = 'AIzaSyDAbHXBou1xv2JlR-nvOjxSSgb5TN7F9JI';

  var page = document.getElementById('store-page');
  if (!page) return;
  var placeId = page.getAttribute('data-place-id');
  var mapEls  = page.querySelectorAll('.es-jsmap');
  if (!placeId && !mapEls.length) return; // nothing to enrich and no maps to draw

  /* ---------- Load Maps JS API (only if not already present) ---------- */
  function loadMaps(cb) {
    if (window.google && window.google.maps && window.google.maps.places) { cb(); return; }
    // If another script already added the loader, wait for it.
    if (window.__esMapsLoading) {
      var t = setInterval(function () {
        if (window.google && window.google.maps && window.google.maps.places) { clearInterval(t); cb(); }
      }, 120);
      return;
    }
    window.__esMapsLoading = true;
    window.__esMapsReady = function () { cb(); };
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' + GMAPS_KEY +
            '&libraries=places&callback=__esMapsReady&loading=async';
    s.async = true;
    document.head.appendChild(s);
  }

  /* ---------- Helpers ---------- */
  function setText(sel, value) {
    page.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
  }

  // Day index from Google weekday_text (Mon-first) → JS getDay (0=Sun..6=Sat)
  var DAY_TO_DOW = { Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6, Sunday: 0 };

  /* ---------- Render: rating + review count ---------- */
  function renderRating(place) {
    if (place.rating != null) {
      setText('[data-place-score]', Number(place.rating).toFixed(1));
    }
    if (place.user_ratings_total != null) {
      var n = place.user_ratings_total;
      // Hero shows "· 327 Google reviews"; reviews panel shows "327 Google reviews"
      page.querySelectorAll('[data-place-count]').forEach(function (el) {
        var prefix = el.textContent.trim().charAt(0) === '·' ? '· ' : '';
        el.textContent = prefix + n + ' Google reviews';
      });
    }
  }

  /* ---------- Render: hours table + open/closed ---------- */
  function renderHours(place) {
    var oh = place.opening_hours;
    if (!oh) return;

    var now = new Date();
    var todayDow = now.getDay();
    var dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

    // Rebuild every hours table from weekday_text (Mon-first from Google)
    if (oh.weekday_text && oh.weekday_text.length) {
      var rowsHtml = oh.weekday_text.map(function (line) {
        var parts = line.split(/:\s+/);            // "Monday: 9:00 AM – 6:00 PM"
        var dayName = parts[0];
        var hours = parts.slice(1).join(': ');
        var dow = DAY_TO_DOW[dayName];
        var isToday = dow === todayDow ? ' is-today' : '';
        return '<div class="hours-row' + isToday + '" data-day="' + dow + '">' +
               '<span class="day">' + dayName + '</span>' +
               '<span class="time">' + hours + '</span></div>';
      }).join('');
      page.querySelectorAll('[data-place-hours]').forEach(function (t) { t.innerHTML = rowsHtml; });
    }

    // Open/closed
    var isOpen;
    try { isOpen = typeof oh.isOpen === 'function' ? oh.isOpen() : oh.open_now; }
    catch (e) { isOpen = oh.open_now; }

    // Status pill(s)
    page.querySelectorAll('[data-place-status]').forEach(function (statusEl) {
      if (isOpen) {
        statusEl.className = 'status status--open';
        statusEl.innerHTML = '<span class="dot"></span>Open now';
      } else if (isOpen === false) {
        statusEl.className = 'status status--closed';
        statusEl.innerHTML = '<span class="dot"></span>Closed';
      }
    });

    // Status label(s) — "Open today · …" or "Opens tomorrow at …"
    var labelText = '';
    if (isOpen) {
      var todayLine = (oh.weekday_text || []).find(function (l) { return l.indexOf(dayNames[todayDow]) === 0; });
      labelText = todayLine ? 'Open today · ' + todayLine.split(/:\s+/).slice(1).join(': ') : 'Open now';
    } else {
      var next = nextOpening(oh.periods, now);
      labelText = next ? 'Opens ' + next.when + ' at ' + next.time : 'Closed';
    }
    page.querySelectorAll('[data-place-statuslabel]').forEach(function (l) { l.textContent = labelText; });
  }

  // Finds the next opening time from Google's opening_hours.periods.
  // period.open = { day: 0-6 (Sun-Sat), time: "0900" }
  function nextOpening(periods, now) {
    if (!periods || !periods.length) return null;
    var nowDay  = now.getDay();
    var nowMins = now.getHours() * 60 + now.getMinutes();
    var dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

    for (var offset = 0; offset < 8; offset++) {
      var checkDay = (nowDay + offset) % 7;
      // earliest opening on checkDay that hasn't passed (only matters for today)
      var best = null;
      for (var i = 0; i < periods.length; i++) {
        var p = periods[i];
        if (!p.open || p.open.day !== checkDay || !p.open.time) continue;
        var mins = parseInt(p.open.time.substr(0, 2), 10) * 60 + parseInt(p.open.time.substr(2, 2), 10);
        if (offset === 0 && mins <= nowMins) continue; // already opened/passed today
        if (best === null || mins < best) best = mins;
      }
      if (best !== null) {
        var when = offset === 0 ? 'today' : offset === 1 ? 'tomorrow' : dayNames[checkDay];
        return { when: when, time: fmtMins(best) };
      }
    }
    return null;
  }

  // 540 → "9:00 AM"
  function fmtMins(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM';
    var hh = h % 12; if (hh === 0) hh = 12;
    return hh + ':' + (m < 10 ? '0' + m : m) + ' ' + ap;
  }

  /* ---------- Render: customer reviews ---------- */
  function renderReviews(place) {
    var wrap = page.querySelector('[data-place-reviews]');
    if (!wrap) return;
    // No live reviews — hide the whole reviews section (no placeholder fallback)
    if (!place.reviews || !place.reviews.length) {
      var section = document.getElementById('reviews');
      if (section) section.style.display = 'none';
      return;
    }

    var star = '<svg><use href="#i-star"/></svg>';
    var cards = place.reviews.slice(0, 6).map(function (r) {
      var initial = (r.author_name || '?').trim().charAt(0).toUpperCase();
      var stars = '';
      for (var i = 0; i < 5; i++) stars += star;
      var text = (r.text || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return '<article class="review-card">' +
        '<div class="stars">' + stars + '</div>' +
        '<p class="review-card__text">' + (text ? '"' + text + '"' : '') + '</p>' +
        '<div class="review-card__who">' +
          '<div class="review-card__avatar">' + initial + '</div>' +
          '<div>' +
            '<div class="review-card__name">' + (r.author_name || '') + '</div>' +
            '<div class="review-card__date">' + (r.relative_time_description || '') + '</div>' +
          '</div>' +
        '</div></article>';
    });
    wrap.innerHTML = cards.join('');
  }

  /* ---------- Render: address + phone ---------- */
  function renderContact(place) {
    if (place.formatted_address) {
      setText('[data-place-address]', place.formatted_address);
    }
    if (place.formatted_phone_number) {
      var phone = place.formatted_phone_number;
      setText('[data-place-phone]', phone);
      var tel = phone.replace(/[\s()\-]/g, '');
      page.querySelectorAll('a[href^="tel:"]').forEach(function (a) {
        a.setAttribute('href', 'tel:' + tel);
      });
    }
  }

  /* ---------- Branded JS maps (replace the embed iframes) ---------- */
  function renderMaps() {
    if (!mapEls.length) return;
    var lat = parseFloat(page.getAttribute('data-lat'));
    var lng = parseFloat(page.getAttribute('data-lng'));
    if (!isFinite(lat) || !isFinite(lng)) return;
    var pos = { lat: lat, lng: lng };
    var PIN = {
      url: 'https://elitesupps.com.au/cdn/shop/files/map-pin.svg?v=1780910073',
      scaledSize: new google.maps.Size(40, 51), // 120x152 SVG ratio
      anchor: new google.maps.Point(20, 51)      // tip at bottom-centre
    };
    mapEls.forEach(function (el) {
      var zoom = parseInt(el.getAttribute('data-zoom'), 10) || 16;
      var map = new google.maps.Map(el, {
        center: pos, zoom: zoom,
        mapTypeControl: false, streetViewControl: false, fullscreenControl: true,
        gestureHandling: 'cooperative'
      });
      new google.maps.Marker({ position: pos, map: map, icon: PIN, title: el.getAttribute('data-title') || '' });
    });
  }

  /* ---------- Fetch ---------- */
  function fetchPlace() {
    var service = new google.maps.places.PlacesService(document.createElement('div'));
    service.getDetails({
      placeId: placeId,
      fields: [
        'formatted_address',
        'formatted_phone_number',
        'opening_hours',
        'rating',
        'user_ratings_total',
        'reviews',
        'url',
        'website',
        'utc_offset_minutes'
      ]
    }, function (place, status) {
      if (status !== google.maps.places.PlacesServiceStatus.OK || !place) return;
      renderRating(place);
      renderHours(place);
      renderReviews(place);
      renderContact(place);
    });
  }

  loadMaps(function () {
    renderMaps();
    if (placeId) fetchPlace();
  });
})();
